import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import urlJoin from 'proper-url-join';
import { buildBaseUrl } from '@core/utils/url.utils';
import { defaultConfig } from 'src/app/app.config';

export interface MaintenanceStatus {
  active: boolean;
  title: string | null;
  description: string | null;
  startTime: string | null;
  endTime: string | null;
}

const NOT_UNDER_MAINTENANCE: MaintenanceStatus = {
  active: false,
  title: null,
  description: null,
  startTime: null,
  endTime: null,
};

/**
 * Consulta GET /api/maintenance-status (fnaUXGateway). Es contenido público sin firma —
 * lo llaman por igual la app con y sin sesión (ver PUBLIC_CONTENT_PREFIXES en el gateway).
 */
@Injectable({
  providedIn: 'root',
})
export class MaintenanceStatusService {
  private http = inject(HttpClient);

  async check(): Promise<MaintenanceStatus> {
    try {
      return await firstValueFrom(this.http.get<MaintenanceStatus>(this.buildUrl()));
    } catch {
      // Si la consulta falla (red/backend caído), no se bloquea a un usuario que quizás no
      // esté en mantenimiento; el próximo poll o el refresh en el punto de acción lo resolverá.
      return NOT_UNDER_MAINTENANCE;
    }
  }

  private buildUrl(): string {
    return urlJoin(
      buildBaseUrl(defaultConfig.serverEntryPoint),
      defaultConfig.apiRootPath,
      'api',
      'maintenance-status'
    );
  }
}
